import React from "react";

import ConfirmDialog from "../../../shared/confirm-dialog";
import { CompareUsersForm } from "./compare-users-form";
import { useTrainingMigrationContext } from "./context/training-migration-provider";
import ScriptStartSuccessDialog from "./shared/script-start-success-dialog";

export const CompareUsersDialog: React.FC = () => {
  const {
    compareUsersDialogOpen,
    setCompareUsersDialogOpen,
    resetCompareUsersFormState,
    handleStartCompareUsers,
  } = useTrainingMigrationContext();

  return (
    <ConfirmDialog
      title="Compare SC and Training Users"
      open={compareUsersDialogOpen}
      setOpen={setCompareUsersDialogOpen}
      onConfirm={async () => {
        await handleStartCompareUsers();
      }}
      width="md"
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Start Script"
      onCancel={() => {
        resetCompareUsersFormState();
        setCompareUsersDialogOpen(false);
      }}
    >
      <CompareUsersForm />
    </ConfirmDialog>
  );
};

export const CompareUsersDialogWrapper: React.FC = () => {
  const {
    compareUsersSuccessDialogOpen,
    setCompareUsersSuccessDialogOpen,
    compareUsersBackgroundJobId,
  } = useTrainingMigrationContext();

  return (
    <>
      <CompareUsersDialog />
      <ScriptStartSuccessDialog
        open={compareUsersSuccessDialogOpen}
        onClose={() => setCompareUsersSuccessDialogOpen(false)}
        backgroundJobId={compareUsersBackgroundJobId}
        scriptName="Compare Users Script"
      />
    </>
  );
};
